<template>
  <div class='EnbFooter'
  v-if="$route.path !== '/likes'"
  :style="{
    backgroundColor: Prefes.rodape.corBackground,
    fontFamily: Prefes.rodape.font,
    color: Prefes.rodape.corFont,
    fontStyle: parseInt(Prefes.rodape.fontStyle) ? 'italic' : '',
    fontWeight: parseInt(Prefes.rodape.fontBold) ? 'bold' : '',
    textDecoration: parseInt(Prefes.rodape.textDecoration) ? 'underline' : '',
    fontSize: Prefes.rodape.fontHeight + 'px'
  }"
  >
    <div class="nets">
      <div class="net">
        <facebook-icon
        @click="push(Empresa.facebook)"
        :color="Prefes.rodape.corFont"
        />
      </div>
      <div class="net">
        <instagram-icon
        @click="push(Empresa.instagram)"
        :color="Prefes.rodape.corFont"
        />
      </div>
      <div class="net">
        <whats-icon :tam="'30px'"
        :color="Prefes.rodape.corFont"
        @click="push(`https://wa.me/55${Empresa.whatsapp}`)"
        />
      </div>
    </div>
    <div class="enbC" style="font-size: 10px;">
      ENB Business © 2022
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import FacebookIcon from '../Icons/FacebookIcon'
import InstagramIcon from '../Icons/InstagramIcon'
import WhatsIcon from '../Icons/WhatsIcon'
export default {
  name: 'EnbFooter',
  components: { FacebookIcon, InstagramIcon, WhatsIcon },
  computed: {
    ...mapGetters(['Prefes', 'Empresa'])
  },
  methods: {
    push (src) {
      window.location.replace(src)
    }
  }
}
</script>

<style scoped>
.EnbFooter {
  width: 98%;
  padding: 1%;
  /* position: absolute;
  bottom: 0; */
  color: #FFFFFF;
}

.nets {
  display: flex;
  justify-content: center;
}

.net {
  padding-left: 3px;
  padding-right: 3px;
}

.enbC {
  padding-top: 3%;
}

@media (max-width: 500px) {
  .EnbFooter {
    padding-bottom: 20%;
  }
}
</style>
